import { IMAGES } from "./images";

// Each service drives a full SEO page at /{slug}/
export const SERVICES = [
  {
    slug: "enseigne-lumineuse",
    category: "Enseignes",
    nav: "Enseigne lumineuse",
    priority: 1,
    image: IMAGES.storefrontNight,
    title: "Enseigne Lumineuse Sur Mesure | Fabrication & Pose – Ronalp Enseigne",
    metaDescription:
      "Fabrication d'enseignes lumineuses LED sur mesure : lettres boîtiers, lettres relief, caissons et enseignes drapeaux. Fabrication et pose France & Suisse.",
    h1: "Fabrication et pose d'enseignes lumineuses sur mesure",
    overline: "Enseigne lumineuse LED",
    intro: [
      "L'enseigne lumineuse est le premier vendeur de votre établissement : elle identifie votre activité le jour et vous rend visible la nuit, parfois à plusieurs centaines de mètres. Ronalp Enseigne conçoit, fabrique dans son atelier et installe des enseignes lumineuses LED entièrement sur mesure, adaptées à votre identité graphique et aux contraintes techniques de votre bâtiment.",
      "Nous maîtrisons l'ensemble de la chaîne : relevé de façade, étude graphique, fabrication des lettres et caissons, choix de l'éclairage LED, pose sur nacelle et raccordement électrique aux normes. Un seul interlocuteur, de la conception jusqu'à la maintenance.",
    ],
    highlights: [
      "Lettres boîtiers & lettres relief",
      "Caissons lumineux simple ou double face",
      "Rétroéclairage LED basse consommation",
      "Étude, fabrication et pose intégrées",
    ],
    sections: [
      {
        h2: "Conception et étude technique",
        body: "Chaque projet démarre par un relevé précis de la façade et une étude graphique. Nous travaillons à partir de votre logo vectorisé pour garantir des lettres fidèles à votre charte. Nous vérifions la faisabilité technique (support, alimentation, accessibilité) et, en France, les règles d'affichage locales avant de valider la fabrication.",
      },
      {
        h2: "Fabrication en atelier : lettres boîtiers et lettres relief",
        body: "Les lettres boîtiers sont des caissons individuels par lettre, en aluminium plié et face plexiglas diffusant, rétroéclairés par LED pour un rendu net et homogène. Les lettres relief (ou lettres découpées) apportent du volume et un éclairage halo discret. Nous découpons, plions, soudons et assemblons chaque élément à l'atelier.",
        bullets: [
          "Lettres boîtiers aluminium + face plexiglas",
          "Lettres relief inox brossé, laqué ou PVC",
          "Logos lumineux reproduits à l'identique",
        ],
      },
      {
        h2: "Éclairage LED : rétroéclairage et éclairage direct",
        body: "Nous sélectionnons des modules LED haute performance pour un éclairage uniforme et une longue durée de vie. Le rétroéclairage (halo projeté sur le mur) crée un effet premium et discret ; l'éclairage direct (face lumineuse) maximise la lisibilité commerciale. La température de couleur est calibrée selon votre image : blanc chaud, blanc neutre ou couleur de marque.",
      },
      {
        h2: "Matériaux et finitions",
        body: "Nous travaillons l'aluminium, l'inox et le plexiglas pour des enseignes durables, résistantes aux intempéries et faciles à entretenir. Les finitions (laquage, brossé, vernis, teintes RAL) sont choisies pour s'harmoniser avec votre façade.",
      },
      {
        h2: "Installation, raccordement et maintenance",
        body: "Nos équipes posent sur nacelle en toute sécurité, fixent les enseignes selon la nature du support et réalisent le raccordement électrique aux normes. Nous assurons également la maintenance et le dépannage pour prolonger la durée de vie de votre installation.",
      },
    ],
    materials: ["Aluminium laqué", "Inox brossé & poli", "Plexiglas (PMMA) diffusant", "Dibond / tôle pliée", "Modules LED longue durée"],
    options: ["Rétroéclairage halo", "Éclairage direct face", "Double face", "Température de couleur au choix", "Teintes RAL personnalisées", "Variateur / minuterie"],
    applications: ["Commerces & boutiques", "Restaurants & bars", "Hôtels", "Pharmacies", "Concessions automobiles", "Bureaux & entreprises"],
    advantages: ["Visibilité jour et nuit", "Image premium et professionnelle", "Basse consommation LED", "Fabrication et pose par le même prestataire", "Durabilité et maintenance assurée"],
    faq: [
      { q: "Quel est le délai de fabrication d'une enseigne lumineuse ?", a: "Comptez généralement 2 à 4 semaines selon la complexité, après validation du bon à tirer et du relevé technique. Les projets avec autorisation administrative peuvent demander plus de temps." },
      { q: "Quelle est la durée de vie d'une enseigne LED ?", a: "Les modules LED que nous utilisons dépassent couramment 50 000 heures. Avec une maintenance simple, une enseigne lumineuse reste performante de nombreuses années." },
      { q: "Faut-il une autorisation pour installer une enseigne ?", a: "En France, l'installation d'une enseigne est soumise à une réglementation locale (RLP, autorisation préalable en mairie). Nous vous accompagnons sur le cadre applicable à votre commune." },
    ],
    related: ["lettres-boitiers", "lettres-relief", "caisson-lumineux", "enseigne-drapeau", "neon-led"],
    relatedLocales: ["enseigne-lumineuse-pays-de-gex", "enseigne-lumineuse-geneve", "enseigne-lumineuse-lyon"],
  },

  {
    slug: "lettres-lumineuses",
    category: "Enseignes",
    nav: "Lettres lumineuses",
    priority: 4,
    image: IMAGES.neonWorkshop,
    title: "Lettres Lumineuses LED | Lettres Boîtiers & Relief – Ronalp Enseigne",
    metaDescription:
      "Lettres lumineuses LED sur mesure : lettres boîtiers, lettres relief et logos lumineux. Fabrication et pose pour commerces et entreprises, France & Suisse.",
    h1: "Lettres lumineuses sur mesure",
    overline: "Lettres LED",
    intro: [
      "Les lettres lumineuses habillent votre façade avec élégance et transforment votre nom en repère visuel. Fabriquées individuellement, elles offrent un rendu haut de gamme, bien plus valorisant qu'un simple panneau.",
      "Ronalp Enseigne fabrique vos lettres lumineuses en boîtiers ou en relief, avec un éclairage LED maîtrisé, puis les installe sur votre devanture ou en hauteur.",
    ],
    highlights: ["Lettres boîtiers rétroéclairées", "Lettres relief halo", "Logos lumineux fidèles", "Pose façade et toiture"],
    sections: [
      { h2: "Lettres boîtiers ou lettres relief ?", body: "Les lettres boîtiers offrent une face lumineuse franche, idéale pour une lisibilité commerciale maximale. Les lettres relief diffusent un halo doux derrière la lettre, pour un effet premium et discret. Nous vous conseillons selon votre image et votre environnement." },
      { h2: "Fabrication et éclairage", body: "Chaque lettre est découpée, pliée et équipée de modules LED en atelier. Nous calibrons la densité de LED pour un éclairage parfaitement uniforme, sans point chaud, dans la température de couleur de votre marque." },
    ],
    materials: ["Aluminium", "Plexiglas diffusant", "Inox", "PVC expansé"],
    options: ["Rétroéclairage halo", "Face lumineuse", "Contour lumineux", "Fixation déportée"],
    applications: ["Commerces", "Restaurants", "Entreprises", "Agences"],
    advantages: ["Rendu premium", "Lisibilité optimale", "Basse consommation", "Sur mesure intégral"],
    faq: [
      { q: "Quelle différence entre lettres boîtiers et lettres relief ?", a: "Les lettres boîtiers ont une face plexiglas lumineuse ; les lettres relief, pleines, projettent un halo lumineux à l'arrière. Les premières sont plus visibles de jour, les secondes plus design." },
      { q: "Peut-on reproduire mon logo en lettres lumineuses ?", a: "Oui, à partir de votre fichier vectoriel nous reproduisons fidèlement typographie, formes et couleurs." },
    ],
    related: ["lettres-boitiers", "lettres-relief", "enseigne-lumineuse", "neon-led"],
    relatedLocales: ["lettres-lumineuses-geneve", "enseigne-lumineuse-geneve"],
  },

  {
    slug: "lettres-boitiers",
    category: "Enseignes",
    nav: "Lettres boîtiers",
    priority: 4,
    image: IMAGES.craftsmanCutting,
    title: "Lettres Boîtiers LED | Fabrication Sur Mesure – Ronalp Enseigne",
    metaDescription:
      "Lettres boîtiers LED sur mesure en aluminium et plexiglas : face lumineuse ou rétroéclairage. Fabrication et pose pour enseignes de façade, France & Suisse.",
    h1: "Lettres boîtiers LED sur mesure",
    overline: "Lettres boîtiers",
    intro: [
      "La lettre boîtier est la référence de l'enseigne haut de gamme : chaque lettre est un caisson indépendant en aluminium, fermé par une face en plexiglas diffusant et rétroéclairé par LED. Le résultat est net, homogène et durable.",
      "Ronalp Enseigne fabrique vos lettres boîtiers à l'atelier et les pose sur façade, bandeau ou support déporté.",
    ],
    highlights: ["Caisson aluminium par lettre", "Face plexiglas diffusant", "Éclairage LED uniforme", "Finitions RAL"],
    sections: [
      { h2: "Construction d'une lettre boîtier", body: "Le corps est réalisé en aluminium plié, la face en plexiglas coloré ou opale diffusant la lumière. Les LED internes sont réparties pour éviter tout point chaud. Les joints sont soignés pour une étanchéité durable en extérieur." },
      { h2: "Options d'éclairage et finitions", body: "Face lumineuse pour la lisibilité, contour lumineux pour le design, ou rétroéclairage halo pour un effet premium. Flancs laqués dans la teinte de votre choix." },
    ],
    materials: ["Aluminium plié", "Plexiglas opale / teinté", "Modules LED", "Visserie inox"],
    options: ["Face lumineuse", "Rétroéclairage halo", "Contour lumineux", "Teintes RAL", "Pose déportée"],
    applications: ["Enseignes de façade", "Bandeaux commerciaux", "Logos d'entreprise", "Toitures"],
    advantages: ["Rendu premium durable", "Éclairage homogène", "Résistance intempéries", "Entretien facile"],
    faq: [
      { q: "Les lettres boîtiers résistent-elles à l'extérieur ?", a: "Oui, l'aluminium et le plexiglas sont conçus pour l'extérieur. Nous soignons l'étanchéité et la fixation pour une tenue durable." },
      { q: "Peut-on avoir des couleurs différentes par lettre ?", a: "Oui, faces et flancs peuvent être déclinés par couleur selon votre charte graphique." },
    ],
    related: ["lettres-relief", "enseigne-lumineuse", "lettres-lumineuses", "caisson-lumineux"],
    relatedLocales: ["enseigne-lumineuse-geneve", "enseigne-lumineuse-pays-de-gex"],
  },

  {
    slug: "lettres-relief",
    category: "Enseignes",
    nav: "Lettres relief",
    priority: 4,
    image: IMAGES.facade,
    title: "Lettres Relief & Lettres Découpées | Enseigne – Ronalp Enseigne",
    metaDescription:
      "Lettres relief en inox, aluminium ou PVC : enseignes volume avec éclairage halo rétroéclairé. Fabrication et pose sur mesure, France & Suisse.",
    h1: "Lettres relief et lettres découpées",
    overline: "Lettres relief",
    intro: [
      "Les lettres relief apportent du volume et de la profondeur à votre façade. Pleines ou avec rétroéclairage halo, elles offrent un rendu architectural et haut de gamme, particulièrement apprécié des bureaux, agences et enseignes institutionnelles.",
      "Nous découpons et assemblons vos lettres relief en inox, aluminium ou PVC, avec ou sans éclairage.",
    ],
    highlights: ["Lettres volume", "Halo rétroéclairé", "Inox, alu, PVC", "Pose déportée précise"],
    sections: [
      { h2: "Lettres relief non lumineuses et rétroéclairées", body: "Les lettres relief peuvent rester brutes (effet matière métal brossé) ou intégrer un rétroéclairage LED projetant un halo élégant sur le mur support. L'effet est idéal pour une réception, un hall ou une façade de bureaux." },
      { h2: "Matériaux et effets", body: "Inox brossé ou poli miroir, aluminium laqué, PVC peint : chaque matière crée une personnalité différente. Les épaisseurs varient de quelques millimètres à plusieurs centimètres selon l'effet recherché." },
    ],
    materials: ["Inox brossé / poli", "Aluminium laqué", "PVC expansé peint", "Laiton"],
    options: ["Rétroéclairage halo", "Sans éclairage", "Épaisseur au choix", "Pose entretoisée"],
    applications: ["Bureaux & halls", "Agences immobilières", "Cabinets", "Façades institutionnelles"],
    advantages: ["Effet volume premium", "Matières nobles", "Discrétion élégante", "Durabilité"],
    faq: [
      { q: "Les lettres relief sont-elles éclairées ?", a: "Elles peuvent l'être via un rétroéclairage halo, ou rester non lumineuses pour un effet matière pur." },
      { q: "Quel matériau choisir ?", a: "L'inox pour un rendu premium durable, l'aluminium laqué pour la couleur, le PVC pour un budget maîtrisé en intérieur." },
    ],
    related: ["lettres-boitiers", "enseigne-lumineuse", "signaletique-interieure"],
    relatedLocales: ["enseigne-lumineuse-geneve", "enseigne-lumineuse-lyon"],
  },

  {
    slug: "enseigne-drapeau",
    category: "Enseignes",
    nav: "Enseigne drapeau",
    priority: 3,
    image: IMAGES.storefront2,
    title: "Enseigne Drapeau Lumineuse | Fabrication & Pose – Ronalp Enseigne",
    metaDescription:
      "Enseigne drapeau lumineuse double face perpendiculaire à la façade : visibilité piétonne optimale. Fabrication et pose sur mesure, France & Suisse.",
    h1: "Enseigne drapeau lumineuse",
    overline: "Enseigne drapeau",
    intro: [
      "L'enseigne drapeau se fixe perpendiculairement à la façade : elle capte le regard des piétons qui longent la rue, bien avant qu'ils ne voient votre bandeau de façade. C'est un atout décisif en centre-ville et en galerie commerciale.",
      "Nous fabriquons des enseignes drapeaux double face, lumineuses ou non, avec potence adaptée à votre devanture.",
    ],
    highlights: ["Double face perpendiculaire", "Visibilité piétonne", "Caisson ou découpe", "Potence sur mesure"],
    sections: [
      { h2: "Visibilité et format", body: "Perpendiculaire à la rue, l'enseigne drapeau multiplie votre visibilité dans les deux sens de circulation. Formats ronds, carrés ou découpés selon votre logo." },
      { h2: "Fabrication et fixation", body: "Caisson lumineux double face ou panneau découpé, monté sur potence métallique dimensionnée pour la sécurité et l'esthétique." },
    ],
    materials: ["Aluminium", "Plexiglas", "Acier potence", "LED double face"],
    options: ["Lumineux / non lumineux", "Forme personnalisée", "Potence design"],
    applications: ["Commerces de rue", "Restaurants", "Galeries commerciales", "Hôtels"],
    advantages: ["Visibilité piétonne maximale", "Double face", "Repère de loin"],
    faq: [
      { q: "L'enseigne drapeau est-elle réglementée ?", a: "Oui, sa saillie et ses dimensions sont encadrées localement. Nous dimensionnons l'enseigne selon les règles de votre commune." },
    ],
    related: ["caisson-lumineux", "enseigne-lumineuse", "totem-publicitaire"],
    relatedLocales: ["enseigne-lumineuse-geneve", "enseigne-lumineuse-annecy"],
  },

  {
    slug: "caisson-lumineux",
    category: "Enseignes",
    nav: "Caisson lumineux",
    priority: 3,
    image: IMAGES.commercial,
    title: "Caisson Lumineux LED | Enseigne Façade Sur Mesure – Ronalp Enseigne",
    metaDescription:
      "Caisson lumineux LED simple ou double face, simple ou double face, pour enseigne de façade et totem. Fabrication et pose sur mesure, France & Suisse.",
    h1: "Caisson lumineux LED sur mesure",
    overline: "Caisson lumineux",
    intro: [
      "Le caisson lumineux est la solution d'enseigne la plus polyvalente : un volume fermé, rétroéclairé par LED, avec une face imprimée ou gravée à votre image. Robuste et très lisible, il convient à la majorité des façades commerciales.",
      "Nous fabriquons vos caissons lumineux en aluminium et plexiglas, en simple ou double face.",
    ],
    highlights: ["Simple ou double face", "Face imprimée ou gravée", "Éclairage LED homogène", "Grand format possible"],
    sections: [
      { h2: "Faces et visuels", body: "Faces en plexiglas imprimé numériquement ou en découpe gravée pour laisser passer uniquement vos éléments. Rendu lumineux uniforme grâce à une LED répartie." },
      { h2: "Formats et poses", body: "Du petit caisson de devanture au grand bandeau de toiture, nous adaptons l'ossature et la fixation à votre support." },
    ],
    materials: ["Aluminium", "Plexiglas imprimé", "Film diffusant", "LED"],
    options: ["Simple / double face", "Face gravée", "Impression numérique", "Grand format"],
    applications: ["Façades commerciales", "Toitures", "Totems", "Galeries"],
    advantages: ["Polyvalence", "Lisibilité forte", "Robustesse", "Rapport qualité-prix"],
    faq: [
      { q: "Peut-on changer la face d'un caisson plus tard ?", a: "Oui, la face est démontable : un changement d'identité visuelle ne nécessite pas de remplacer tout le caisson." },
    ],
    related: ["enseigne-lumineuse", "enseigne-drapeau", "totem-publicitaire"],
    relatedLocales: ["enseigne-lumineuse-lyon", "enseigne-lumineuse-geneve"],
  },

  {
    slug: "neon-led",
    category: "Enseignes",
    nav: "Néon LED",
    priority: 3,
    image: IMAGES.neonWorkshop,
    title: "Néon LED Sur Mesure | Enseigne Néon Flex – Ronalp Enseigne",
    metaDescription:
      "Néon LED (néon flex) sur mesure : logos, slogans et décors lumineux pour vitrines et intérieurs. Fabrication et pose, France & Suisse.",
    h1: "Néon LED sur mesure",
    overline: "Néon LED",
    intro: [
      "Le néon LED (néon flex) recrée l'esthétique chaleureuse du néon traditionnel, sans fragilité ni surconsommation. Idéal pour un logo, un slogan ou un décor lumineux en vitrine, en intérieur ou en façade abritée.",
      "Nous façonnons vos néons LED à partir de votre dessin, sur support transparent ou découpé.",
    ],
    highlights: ["Néon flex LED", "Logos & slogans", "Couleurs vives", "Intérieur & vitrine"],
    sections: [
      { h2: "Design et couleurs", body: "Le néon LED se plie à toutes les formes : lettres manuscrites, pictogrammes, slogans. Large palette de couleurs, intensité réglable, fonctionnement silencieux." },
      { h2: "Supports et pose", body: "Monté sur plaque acrylique transparente, sur découpe à la forme ou fixé directement au mur. Installation simple en intérieur comme en vitrine." },
    ],
    materials: ["Néon flex LED", "Plaque acrylique", "Alimentation basse tension"],
    options: ["Couleur unique / multicolore", "Variateur", "Support transparent / découpé"],
    applications: ["Bars & restaurants", "Boutiques", "Décoration intérieure", "Événementiel"],
    advantages: ["Esthétique néon", "Faible consommation", "Robuste et silencieux", "Sur mesure"],
    faq: [
      { q: "Le néon LED consomme-t-il beaucoup ?", a: "Non, il fonctionne en basse tension et consomme très peu, contrairement au néon à gaz traditionnel." },
    ],
    related: ["lettres-lumineuses", "enseigne-lumineuse", "vitrophanie"],
    relatedLocales: ["enseigne-lumineuse-geneve", "lettres-lumineuses-geneve"],
  },

  {
    slug: "totem-publicitaire",
    category: "Signalétique",
    nav: "Totems",
    priority: 5,
    image: IMAGES.facade,
    title: "Totem Publicitaire Lumineux | Signalétique – Ronalp Enseigne",
    metaDescription:
      "Totem publicitaire lumineux sur mesure : signalétique verticale pour zones d'activité, concessions et parkings. Fabrication et pose, France & Suisse.",
    h1: "Totem publicitaire lumineux",
    overline: "Totem",
    intro: [
      "Le totem publicitaire est un repère vertical, idéal en bord de route, en zone d'activité ou sur un parking. Il regroupe une ou plusieurs enseignes et guide vos visiteurs de loin.",
      "Nous concevons des totems lumineux mono ou multi-enseignes, dimensionnés et fondés selon le site.",
    ],
    highlights: ["Repère vertical", "Mono ou multi-marques", "Lumineux LED", "Génie civil inclus"],
    sections: [
      { h2: "Conception et structure", body: "Structure acier galvanisé, habillage aluminium, faces lumineuses en plexiglas. Nous étudions le massif béton et l'ancrage selon la portance du sol et la prise au vent." },
      { h2: "Applications", body: "Concessions automobiles, centres commerciaux, zones d'activité, hôtels et stations : le totem oriente et affirme votre présence." },
    ],
    materials: ["Acier galvanisé", "Aluminium", "Plexiglas", "LED"],
    options: ["Mono / multi-enseignes", "Simple / double face", "Hauteur sur mesure"],
    applications: ["Concessions", "Zones d'activité", "Centres commerciaux", "Hôtels"],
    advantages: ["Visibilité longue distance", "Multi-marques", "Structure durable"],
    faq: [
      { q: "Un totem nécessite-t-il des fondations ?", a: "Oui, un massif béton dimensionné assure la stabilité face au vent. Nous réalisons l'étude et la pose complète." },
    ],
    related: ["caisson-lumineux", "signaletique-exterieure", "habillage-facade"],
    relatedLocales: ["enseigne-lumineuse-lyon", "enseigne-lumineuse-ain"],
  },

  {
    slug: "signaletique",
    category: "Signalétique",
    nav: "Signalétique",
    priority: 5,
    image: IMAGES.commercial,
    title: "Signalétique Professionnelle Intérieure & Extérieure | Ronalp Enseigne",
    metaDescription:
      "Signalétique professionnelle intérieure et extérieure : plaques, panneaux, signalétique directionnelle et industrielle. Conception et pose, France & Suisse.",
    h1: "Signalétique professionnelle",
    overline: "Signalétique",
    intro: [
      "Une bonne signalétique guide, informe et rassure. De la plaque professionnelle à la signalétique directionnelle d'un bâtiment entier, elle structure l'expérience de vos visiteurs et renforce votre image.",
      "Ronalp Enseigne conçoit et pose des systèmes de signalétique cohérents, lisibles et durables, en intérieur comme en extérieur.",
    ],
    highlights: ["Plaques & panneaux", "Directionnelle", "Intérieure & extérieure", "Normes PMR"],
    sections: [
      { h2: "Une signalétique cohérente", body: "Nous concevons des gammes complètes : plaques de porte, totems d'accueil, fléchage directionnel, panneaux réglementaires. Typographie, couleurs et matériaux restent cohérents avec votre identité." },
      { h2: "Matériaux et accessibilité", body: "Aluminium, plexiglas, dibond, PVC : nous choisissons le support selon l'usage. Nous intégrons les exigences d'accessibilité (contrastes, braille, pictogrammes normalisés) quand elles s'appliquent." },
    ],
    materials: ["Aluminium", "Plexiglas", "Dibond", "PVC", "Vinyle"],
    options: ["Intérieure", "Extérieure", "Directionnelle", "Braille / PMR"],
    applications: ["Entreprises", "Collectivités", "Santé", "Commerces", "Industrie"],
    advantages: ["Lisibilité", "Cohérence de marque", "Durabilité", "Conformité"],
    faq: [
      { q: "Proposez-vous une signalétique accessible PMR ?", a: "Oui, nous intégrons contrastes, reliefs et braille selon les normes d'accessibilité en vigueur." },
    ],
    related: ["signaletique-interieure", "signaletique-exterieure", "totem-publicitaire", "communication-visuelle"],
    relatedLocales: ["signaletique-geneve", "signaletique-lausanne"],
  },

  {
    slug: "signaletique-interieure",
    category: "Signalétique",
    nav: "Signalétique intérieure",
    priority: 5,
    image: IMAGES.workshopWelding,
    title: "Signalétique Intérieure | Plaques & Directionnel – Ronalp Enseigne",
    metaDescription:
      "Signalétique intérieure : plaques de porte, signalétique directionnelle, habillage mural et accueil. Conception et pose sur mesure, France & Suisse.",
    h1: "Signalétique intérieure",
    overline: "Signalétique intérieure",
    intro: [
      "La signalétique intérieure oriente vos visiteurs et valorise vos espaces : accueil, plaques de bureaux, numéros de salles, fléchage et murs d'image. Elle doit être lisible, élégante et évolutive.",
      "Nous concevons des systèmes modulaires faciles à mettre à jour, dans des matériaux adaptés à vos locaux.",
    ],
    highlights: ["Plaques de porte", "Fléchage directionnel", "Mur d'accueil", "Systèmes évolutifs"],
    sections: [
      { h2: "Accueil et orientation", body: "Logo de réception, totem d'accueil, plan directionnel : nous créons un parcours fluide pour vos visiteurs." },
      { h2: "Modularité", body: "Porte-étiquettes interchangeables pour les espaces qui évoluent souvent, afin de mettre à jour un nom sans refaire la plaque." },
    ],
    materials: ["Plexiglas", "Aluminium", "Vinyle", "Dibond"],
    options: ["Plaques fixes / modulaires", "Rétroéclairage", "Découpe logo"],
    applications: ["Bureaux", "Santé", "Hôtels", "Établissements publics"],
    advantages: ["Orientation claire", "Image soignée", "Mise à jour facile"],
    faq: [
      { q: "Peut-on mettre à jour une plaque facilement ?", a: "Oui, nos systèmes modulaires permettent de changer un nom sans remplacer tout le support." },
    ],
    related: ["signaletique", "signaletique-exterieure", "lettres-relief"],
    relatedLocales: ["signaletique-geneve", "signaletique-lausanne"],
  },

  {
    slug: "signaletique-exterieure",
    category: "Signalétique",
    nav: "Signalétique extérieure",
    priority: 5,
    image: IMAGES.facade,
    title: "Signalétique Extérieure | Panneaux & Totems – Ronalp Enseigne",
    metaDescription:
      "Signalétique extérieure durable : panneaux, totems directionnels, signalétique de parking et de zone d'activité. Conception et pose, France & Suisse.",
    h1: "Signalétique extérieure",
    overline: "Signalétique extérieure",
    intro: [
      "La signalétique extérieure guide vos visiteurs jusqu'à votre porte et sécurise vos accès. Elle doit résister aux intempéries et rester parfaitement lisible dans le temps.",
      "Nous fabriquons panneaux, totems directionnels et signalétique de parking en matériaux robustes.",
    ],
    highlights: ["Panneaux durables", "Totems directionnels", "Parking & accès", "Résistance intempéries"],
    sections: [
      { h2: "Guidage et sécurité", body: "Du panneau d'entrée au fléchage de parking, nous structurons les flux et sécurisons la circulation sur votre site." },
      { h2: "Matériaux extérieurs", body: "Aluminium, dibond et vinyles anti-UV garantissent une tenue durable face au soleil et à la pluie." },
    ],
    materials: ["Aluminium", "Dibond", "Vinyle anti-UV", "Acier"],
    options: ["Panneaux", "Totems directionnels", "Rétroéclairage", "Réfléchissant"],
    applications: ["Zones d'activité", "Parkings", "Industrie", "Collectivités"],
    advantages: ["Durabilité extérieure", "Lisibilité", "Sécurité des flux"],
    faq: [
      { q: "Vos panneaux résistent-ils aux UV ?", a: "Oui, nous utilisons des encres et vinyles anti-UV et des supports traités pour l'extérieur." },
    ],
    related: ["signaletique", "totem-publicitaire", "habillage-facade"],
    relatedLocales: ["enseigne-lumineuse-lyon", "signaletique-geneve"],
  },

  {
    slug: "communication-visuelle",
    category: "Communication visuelle",
    nav: "Communication visuelle",
    priority: 3,
    image: IMAGES.storefront2,
    title: "Communication Visuelle & Signalétique Professionnelle | Ronalp Enseigne",
    metaDescription:
      "Communication visuelle pour entreprises et commerces : enseignes, signalétique, adhésifs, vitrophanie, marquage véhicule, totems et impression grand format.",
    h1: "Communication visuelle pour entreprises et commerces",
    overline: "Communication visuelle",
    intro: [
      "La communication visuelle rassemble tous les supports qui donnent corps à votre image : enseignes, signalétique, adhésifs, vitrophanie, marquage de véhicules, totems, panneaux, habillage de façade et impression grand format. Bien orchestrés, ils créent une identité cohérente, du trottoir jusqu'à vos documents.",
      "Ronalp Enseigne conçoit, fabrique et pose l'ensemble de ces supports, pour une image homogène sur tous vos points de contact.",
    ],
    highlights: ["Enseignes & signalétique", "Vitrophanie & adhésifs", "Marquage véhicule", "Impression grand format"],
    sections: [
      { h2: "Une image cohérente, du trottoir au véhicule", body: "Nous déclinons votre identité sur tous les supports : enseigne de façade, vitrine, totem, flotte de véhicules, habillage de stand. La cohérence renforce la mémorisation de votre marque." },
      { h2: "Nos supports de communication visuelle", body: "Enseignes et caissons lumineux, signalétique intérieure et extérieure, vitrophanie et marquage vitrine, films adhésifs, covering de véhicules, totems et panneaux, habillage de façade, PLV et impression grand format.", bullets: ["Vitrophanie & marquage vitrine", "Films adhésifs & covering", "Marquage véhicule", "Totems & panneaux", "Habillage de façade", "Impression grand format & PLV"] },
      { h2: "Conseil et production intégrée", body: "De la création graphique à la pose, nous gérons la production en interne pour maîtriser qualité, délais et budget." },
    ],
    materials: ["Vinyles adhésifs", "Films dépolis / microperforés", "Bâches", "Dibond", "Aluminium"],
    options: ["Création graphique", "Impression grand format", "Pose sur site", "Covering intégral"],
    applications: ["Commerces", "Entreprises", "Événementiel", "Flottes de véhicules"],
    advantages: ["Image cohérente", "Production intégrée", "Multi-supports", "Pose professionnelle"],
    faq: [
      { q: "Gérez-vous aussi la création graphique ?", a: "Oui, nous pouvons créer ou adapter vos visuels, ou travailler à partir des fichiers de votre agence." },
      { q: "Pouvez-vous équiper toute une flotte de véhicules ?", a: "Oui, nous réalisons le marquage ou le covering complet de flottes, avec une charte homogène." },
    ],
    related: ["vitrophanie", "marquage-vitrine", "film-adhesif", "marquage-vehicule", "habillage-facade", "impression-grand-format"],
    relatedLocales: ["communication-visuelle-geneve", "communication-visuelle-lyon", "communication-visuelle-ain"],
  },

  {
    slug: "vitrophanie",
    category: "Communication visuelle",
    nav: "Vitrophanie",
    priority: 5,
    image: IMAGES.commercial,
    title: "Vitrophanie & Marquage Vitrine | Adhésif Vitre – Ronalp Enseigne",
    metaDescription:
      "Vitrophanie sur mesure : adhésifs dépolis, microperforés et découpes pour vitrines. Habillage de vitre pour commerces et bureaux, France & Suisse.",
    h1: "Vitrophanie et habillage de vitrine",
    overline: "Vitrophanie",
    intro: [
      "La vitrophanie habille vos vitres : elle communique vos horaires et offres, filtre les vues pour plus d'intimité et renforce votre image de marque. C'est un support économique à fort impact.",
      "Nous réalisons vos adhésifs de vitrine en découpe, impression ou film dépoli, posés avec soin sans bulles.",
    ],
    highlights: ["Adhésif dépoli & microperforé", "Découpe logo", "Intimité & filtrage", "Pose sans bulle"],
    sections: [
      { h2: "Types de vitrophanie", body: "Film dépoli pour l'intimité des bureaux, microperforé pour voir de l'intérieur sans être vu, découpe de lettrage, impression quadri pleine couleur." },
      { h2: "Pose soignée", body: "Nous préparons la vitre et posons à la raclette pour un rendu net, durable et sans bulle." },
    ],
    materials: ["Vinyle adhésif", "Film dépoli", "Microperforé", "Vinyle de découpe"],
    options: ["Découpe", "Impression quadri", "Dépoli / sablé", "Microperforé"],
    applications: ["Commerces", "Bureaux", "Agences", "Restaurants"],
    advantages: ["Impact immédiat", "Intimité modulable", "Budget maîtrisé", "Repositionnable"],
    faq: [
      { q: "La vitrophanie s'enlève-t-elle facilement ?", a: "Oui, les adhésifs se retirent proprement sans endommager la vitre, idéal pour les opérations saisonnières." },
    ],
    related: ["marquage-vitrine", "film-adhesif", "communication-visuelle"],
    relatedLocales: ["communication-visuelle-geneve", "communication-visuelle-lyon"],
  },

  {
    slug: "marquage-vitrine",
    category: "Communication visuelle",
    nav: "Marquage vitrine",
    priority: 5,
    image: IMAGES.storefront2,
    title: "Marquage Vitrine | Lettrage & Adhésif Vitrine – Ronalp Enseigne",
    metaDescription:
      "Marquage vitrine : lettrage adhésif, logo, horaires et promotions sur vos vitres. Conception et pose soignée pour commerces, France & Suisse.",
    h1: "Marquage de vitrine",
    overline: "Marquage vitrine",
    intro: [
      "Le marquage vitrine transforme votre devanture en support de communication : nom, logo, horaires, promotions et visuels saisonniers. Bien pensé, il attire le regard et déclenche l'entrée en boutique.",
      "Nous concevons et posons votre marquage vitrine en lettrage découpé ou impression.",
    ],
    highlights: ["Lettrage découpé", "Horaires & promos", "Visuels saisonniers", "Pose nette"],
    sections: [
      { h2: "Contenu et composition", body: "Nous équilibrons information et transparence : votre vitrine informe sans masquer l'intérieur, pour rester accueillante." },
      { h2: "Durable ou temporaire", body: "Lettrage permanent pour l'identité, adhésifs repositionnables pour les opérations ponctuelles." },
    ],
    materials: ["Vinyle de découpe", "Vinyle imprimé", "Film couleur"],
    options: ["Découpe", "Impression", "Permanent / temporaire"],
    applications: ["Commerces", "Restaurants", "Agences"],
    advantages: ["Attractivité", "Souplesse", "Coût maîtrisé"],
    faq: [
      { q: "Peut-on changer le marquage à chaque saison ?", a: "Oui, nous prévoyons des éléments permanents et des adhésifs temporaires faciles à remplacer." },
    ],
    related: ["vitrophanie", "film-adhesif", "communication-visuelle"],
    relatedLocales: ["communication-visuelle-lyon", "communication-visuelle-geneve"],
  },

  {
    slug: "film-adhesif",
    category: "Communication visuelle",
    nav: "Films adhésifs",
    priority: 5,
    image: IMAGES.craftsmanCutting,
    title: "Films Adhésifs & Covering | Habillage Adhésif – Ronalp Enseigne",
    metaDescription:
      "Films adhésifs sur mesure : habillage mural, mobilier, sol et covering. Impression et pose d'adhésifs décoratifs et techniques, France & Suisse.",
    h1: "Films adhésifs et covering",
    overline: "Films adhésifs",
    intro: [
      "Les films adhésifs habillent presque toutes les surfaces : murs, mobilier, sols, portes et parois. Ils permettent de transformer un espace rapidement, sans travaux lourds, pour un impact immédiat.",
      "Nous imprimons et posons des adhésifs décoratifs et techniques sur mesure.",
    ],
    highlights: ["Habillage mural", "Mobilier & sols", "Covering", "Pose technique"],
    sections: [
      { h2: "Applications décoratives", body: "Fresques murales, habillage de comptoir, décoration de bureaux : l'adhésif met en scène vos espaces et votre marque." },
      { h2: "Films techniques", body: "Films anti-chaleur, dépolis, occultants ou de sécurité, posés proprement sur vos surfaces." },
    ],
    materials: ["Vinyle imprimé", "Film dépoli", "Film de sol", "Laminations de protection"],
    options: ["Décoratif", "Technique", "Sol antidérapant", "Lamination"],
    applications: ["Bureaux", "Commerces", "Restaurants", "Événementiel"],
    advantages: ["Transformation rapide", "Sans travaux", "Polyvalence"],
    faq: [
      { q: "Peut-on poser des adhésifs au sol ?", a: "Oui, avec des films dédiés antidérapants et laminés pour résister au passage." },
    ],
    related: ["vitrophanie", "marquage-vehicule", "communication-visuelle"],
    relatedLocales: ["communication-visuelle-lyon", "communication-visuelle-ain"],
  },

  {
    slug: "marquage-vehicule",
    category: "Communication visuelle",
    nav: "Marquage véhicules",
    priority: 5,
    image: IMAGES.commercial,
    title: "Marquage Véhicule & Covering | Flocage Auto – Ronalp Enseigne",
    metaDescription:
      "Marquage véhicule et covering : flocage partiel ou total de voitures, utilitaires et flottes. Conception et pose professionnelle, France & Suisse.",
    h1: "Marquage et covering de véhicules",
    overline: "Marquage véhicule",
    intro: [
      "Un véhicule marqué est une enseigne mobile qui travaille pour vous à chaque trajet. Du simple lettrage au covering intégral, le marquage véhicule démultiplie votre visibilité sur toute votre zone.",
      "Nous concevons et posons le marquage de vos véhicules, de l'unité à la flotte complète.",
    ],
    highlights: ["Lettrage ou covering total", "Utilitaires & flottes", "Films qualité auto", "Pose atelier"],
    sections: [
      { h2: "Du lettrage au covering", body: "Marquage partiel (coordonnées, logo) ou covering total qui change la couleur et l'image du véhicule. Nous adaptons la solution à votre budget et à vos objectifs." },
      { h2: "Qualité et durabilité", body: "Films coulés de qualité automobile, posés en atelier sur carrosserie préparée, pour une tenue durable et un retrait propre." },
    ],
    materials: ["Films coulés auto", "Vinyle de découpe", "Lamination"],
    options: ["Partiel", "Covering total", "Flotte", "Films couleur / carbone"],
    applications: ["Artisans", "Sociétés de services", "Flottes", "Commerces"],
    advantages: ["Publicité mobile", "Image homogène de flotte", "Protection carrosserie"],
    faq: [
      { q: "Le covering abîme-t-il la peinture ?", a: "Non, posé et retiré dans les règles, le film protège même la carrosserie d'origine." },
    ],
    related: ["film-adhesif", "communication-visuelle", "impression-grand-format"],
    relatedLocales: ["communication-visuelle-lyon", "communication-visuelle-ain"],
  },

  {
    slug: "habillage-facade",
    category: "Communication visuelle",
    nav: "Habillage façade",
    priority: 5,
    image: IMAGES.facade,
    title: "Habillage de Façade | Bardage & Grand Format – Ronalp Enseigne",
    metaDescription:
      "Habillage de façade sur mesure : bardage décoratif, bâches grand format et panneaux composites pour valoriser votre bâtiment. Conception et pose, France & Suisse.",
    h1: "Habillage de façade",
    overline: "Habillage façade",
    intro: [
      "L'habillage de façade métamorphose l'apparence de votre bâtiment et affirme votre marque sur toute sa surface. Panneaux composites, bardage, bâches tendues : la façade devient un support de communication à part entière.",
      "Nous concevons et posons des habillages de façade durables, du commerce à l'immeuble d'entreprise.",
    ],
    highlights: ["Panneaux composites", "Bâches grand format", "Bardage décoratif", "Pose en hauteur"],
    sections: [
      { h2: "Solutions d'habillage", body: "Panneaux dibond laqués ou imprimés, bâches tendues sur ossature, lames de bardage : nous choisissons la technique selon le support et l'effet recherché." },
      { h2: "Pose sécurisée", body: "Travail sur nacelle ou échafaudage, fixations adaptées au bâti, dans le respect des règles de sécurité." },
    ],
    materials: ["Dibond / composite", "Bâche PVC", "Bardage", "Ossature aluminium"],
    options: ["Imprimé", "Laqué", "Rétroéclairé", "Grand format"],
    applications: ["Commerces", "Entreprises", "Concessions", "Chantiers"],
    advantages: ["Transformation visuelle forte", "Durabilité", "Grande surface d'expression"],
    faq: [
      { q: "Peut-on habiller une façade existante sans tout rénover ?", a: "Oui, une ossature rapportée permet d'habiller l'existant sans gros œuvre." },
    ],
    related: ["impression-grand-format", "totem-publicitaire", "communication-visuelle"],
    relatedLocales: ["communication-visuelle-lyon", "enseigne-lumineuse-geneve"],
  },

  {
    slug: "impression-grand-format",
    category: "Communication visuelle",
    nav: "Impression grand format",
    priority: 5,
    image: IMAGES.workshopWelding,
    title: "Impression Grand Format | Bâches & Panneaux – Ronalp Enseigne",
    metaDescription:
      "Impression grand format : bâches, panneaux, PLV, kakémonos et visuels publicitaires haute définition. Production et pose, France & Suisse.",
    h1: "Impression grand format",
    overline: "Grand format",
    intro: [
      "L'impression grand format donne de la puissance à vos messages : bâches de chantier, panneaux publicitaires, kakémonos, PLV et visuels événementiels. Haute définition, couleurs fidèles et supports adaptés à chaque usage.",
      "Nous imprimons et finissons vos supports grand format, prêts à poser.",
    ],
    highlights: ["Bâches & panneaux", "PLV & kakémonos", "Haute définition", "Finitions prêtes à poser"],
    sections: [
      { h2: "Supports et usages", body: "Bâches micro-aérées pour l'extérieur, panneaux rigides, roll-up et kakémonos pour l'événementiel, adhésifs pour l'intérieur : chaque support est choisi selon sa destination." },
      { h2: "Qualité d'impression", body: "Encres résistantes, profils colorimétriques maîtrisés et finitions soignées (œillets, ourlets, lamination)." },
    ],
    materials: ["Bâche PVC", "Panneaux rigides", "Vinyle", "Textile"],
    options: ["Œillets / ourlets", "Lamination", "Découpe à la forme", "Anti-UV"],
    applications: ["Chantiers", "Événementiel", "Commerces", "Salons"],
    advantages: ["Fort impact", "Rapidité", "Supports variés"],
    faq: [
      { q: "Quels formats pouvez-vous imprimer ?", a: "Des petits panneaux aux très grandes bâches de façade, assemblées si nécessaire pour les surfaces exceptionnelles." },
    ],
    related: ["habillage-facade", "marquage-vehicule", "communication-visuelle"],
    relatedLocales: ["communication-visuelle-lyon", "communication-visuelle-geneve"],
  },
];

export const SERVICES_BY_SLUG = Object.fromEntries(SERVICES.map((s) => [s.slug, s]));

export const getService = (slug) => SERVICES_BY_SLUG[slug];
